import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';

export class InputBoolean extends LitElement {
  @property() checked = false;
  @property() readonly = false;
  @property() disabled = false;
  @property() label = '';

  render() {
    const clickEvent = (e: Event) => {
      e.stopPropagation();
      e.preventDefault();
      if (this.readonly || this.disabled) return;
      this.checked = !this.checked;
      this.click();
    };
    // Use webmodule-icon (not a raw FontAwesome <i>) so the check glyph renders when
    // this control is placed inside a shadow-DOM host such as <webmodule-table>, where
    // the global FontAwesome CSS cannot reach.
    const color = this.disabled || !this.checked ? 'gray' : 'primary';
    return this.checked
      ? html`<span @click=${clickEvent}>
          <webmodule-icon library="fa" name="fas-square-check" color=${color}></webmodule-icon>
          ${this.label}
        </span>`
      : html`<span @click=${clickEvent}>
          <webmodule-icon library="fa" name="far-square" color=${color}></webmodule-icon>
          ${this.label}
        </span>`;
  }

  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }
}
